const setInnerHTML = htmlBlob => ({
  dangerouslySetInnerHTML: { __html: htmlBlob },
})

export default setInnerHTML
